import { render, staticRenderFns } from "./IconLibrary.vue?vue&type=template&id=4b618f56&"
import script from "./IconLibrary.vue?vue&type=script&lang=js&"
export * from "./IconLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IconLibrary.vue"
export default component.exports